import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IOrderAssociateUnitModel } from '@apps-common/types/management/order'

export const associateUnitOrder = async (model: IOrderAssociateUnitModel): Promise<boolean> =>
  axios.post(`/management/order/AssociateUnitsOrder`, model).then((res) => res?.data?.data)

type Props = {
  model: IOrderAssociateUnitModel
}

export const useManagementAssociateUnitOrder = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['associateUnitOrder'],
    mutationFn: ({ model }: Props) => associateUnitOrder(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated order.')
      }
    },
    onError: (e) => {
      if (notify) {
        toastError(e?.message || 'Failed to update order.')
      }
    },
    throwOnError: false
  })
